export default "__VITE_ASSET__27097e62__"